import { Routes } from '@angular/router';
import { AppContainer } from './app-container';
import { AppLayout } from './app-layout';
import { Guest } from '@features/sharing/guest/guest';
import { CaseLibrary } from '@features/case-library/case-library';
import { AuthGuard, LogoutGuard, OrganizationGuard } from '@core/auth';
import { GuestGuard } from '@core/auth/guest.guard';
import { AuthErrorPage } from '@features/auth-error/auth-error-page';
// From the file and not the barrel: the barrel re-exports the page, which would land in the
// initial bundle and defeat the lazy load below.
import { LiveReportRoomGuard } from '@features/live-report/routing/live-report-room.guard';

export const routes: Routes = [
  { path: 'logout', canActivate: [LogoutGuard], component: AppContainer },
  {
    path: 'auth-error',
    component: AuthErrorPage,
    title: 'Medinbox Intelligence - Authentication Error',
  },
  {
    path: 'shared',
    canActivate: [GuestGuard],
    component: Guest,
    title: 'Medinbox Intelligence - Guest Access',
  },
  {
    path: 'live-report/:roomSlug',
    /*
     `AuthGuard` while the kiosk access is being built: this screen is meant to be opened by a room
     display with no account at all (#227), and the token that would let it does not exist yet.
    */
    canActivate: [AuthGuard, LiveReportRoomGuard],
    loadComponent: () =>
      import('@features/live-report/live-report-page').then((m) => m.LiveReportPage),
    title: 'Medinbox Intelligence - live report',
  },
  {
    path: '',
    component: AppContainer,
    title: 'Medinbox Intelligence',
    canActivate: [OrganizationGuard],
    children: [
      {
        // The layout draws the application bar once, above every authenticated page.
        path: '',
        component: AppLayout,
        children: [
          {
            path: '',
            component: CaseLibrary,
            title: 'Medinbox Intelligence - Library',
            canActivate: [AuthGuard],
          },
          {
            // Lazy, and preloaded once the application is up: the first case opened does not wait for it.
            path: 'video-details/:id',
            loadComponent: () =>
              import('@features/case-details/case-details-page').then((m) => m.CaseDetailsPage),
            title: 'Medinbox Intelligence - video',
            canActivate: [AuthGuard],
            // The account menu offers its case entries (Share, Download case context) on this route.
            data: { caseMenu: true },
          },
          {
            path: 'video-edit/:id',
            loadComponent: () =>
              import('@features/case-details/video-cut-page').then((m) => m.VideoCutPage),
          },
          {
            // Lazy: an administration screen reached on purpose has no place in the initial bundle.
            path: 'admin/rooms',
            loadComponent: () =>
              import('@features/admin/rooms/rooms-page').then((m) => m.RoomsPage),
            title: 'Medinbox Intelligence - rooms',
            canActivate: [AuthGuard],
          },
          {
            // The slug of the room, the identifier its creation and its listing both report.
            path: 'admin/rooms/:roomId',
            loadComponent: () =>
              import('@features/admin/rooms/room-detail-page').then((m) => m.RoomDetailPage),
            title: 'Medinbox Intelligence - room setup',
            canActivate: [AuthGuard],
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '/' },
];
